import { useState } from "react";

import { CompanyTitledPage } from "../../TitledPage";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Pagination from "@mui/material/Pagination";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import { grey } from "@mui/material/colors";
import { getDateAfter, getYearMonthDateDisplay } from "../../../utils/utils";

// 価格表の行の最大数
const maxPriceTableRows = 8;

// 価格表カラム名
const priceTableColumnNames = {
  name: "商品",
  place: "産地",
  size: "発注規格",
  market_price: "市況価格",
  unit: "発注\n単位",
  order_units: "注文数",
};

// 蔬菜注文データ　※ダミー
const vegetableOrderList = [
  {
    name: "新玉葱",
    place: "長崎　他",
    size: "2L 10kg",
    market_price: 3200,
    unit: "ケース",
    order_units: 3,
  },
  {
    name: "ブロッコリー",
    place: "愛知　他",
    size: "L 株",
    market_price: 100,
    unit: "株",
    order_units: 2,
  },
];

// 果物注文データ　※ダミー
const fruitOrderList = [
  {
    name: "バナナ",
    place: "フィリピン他",
    size: "13kg",
    market_price: 3300,
    unit: "箱",
    order_units: 4,
  },
];

// スポット注文データ　※ダミー
const spotOrderList = [
  {
    name: "テスト菜",
    place: "テスト県",
    size: "L",
    market_price: 1200,
    unit: "ケース",
    order_units: 1,
  },
];

// 価格表タブ内容
// props...value = タブ番号 tabPosition = 現在タブ番号のstate
function TableTabContent(props) {
  const value = props.value;
  const tabPosition = props.tabPosition;

  return <Box hidden={tabPosition !== value}>{props.children}</Box>;
}

// 価格表(編集用)
// props...
// data = 表のデータ, minIndex = 価格表全体配列におけるこの表の最小index,
// updateInputPrice...価格表データ価格更新関数(index, value) => void,
// updateInputLoss...価格表データ欠品更新関数(index, value) => void,
function PriceEditTable(props) {
  const priceTableData = props.data;

  const minIndex = props.minIndex;

  // 表のデータ行1行分
  function PriceTableRow(props) {
    const index = props.index;

    const data = props.data;

    return (
      <TableRow key={index}>
        <TableCell
          component="th"
          scope="row"
          sx={{ fontWeight: "bold", fontSize: 20, height: 28, width: 150 }}
        >
          {data.name}
        </TableCell>
        <TableCell>{data.place}</TableCell>
        <TableCell>{data.size}</TableCell>
        <TableCell sx={{ textAlign: "right" }}>
          {data.market_price.toLocaleString()}
        </TableCell>
        <TableCell>{data.unit}</TableCell>
        <TableCell sx={{ textAlign: "right" }}>{data.order_units}</TableCell>
      </TableRow>
    );
  }

  if (priceTableData && priceTableData.length > 0) {
    return (
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: grey[100] }}>
                {priceTableColumnNames.name}
              </TableCell>
              <TableCell sx={{ backgroundColor: grey[100] }}>
                {priceTableColumnNames.place}
              </TableCell>
              <TableCell sx={{ backgroundColor: grey[100] }}>
                {priceTableColumnNames.size}
              </TableCell>
              <TableCell sx={{ backgroundColor: grey[100] }}>
                {priceTableColumnNames.market_price}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: grey[100], whiteSpace: "pre-wrap" }}
              >
                {priceTableColumnNames.unit}
              </TableCell>
              <TableCell
                sx={{ backgroundColor: grey[100], whiteSpace: "pre-wrap" }}
              >
                {priceTableColumnNames.order_units}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {priceTableData.map((data, i) => (
              <PriceTableRow key={i} data={data} index={i + minIndex} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return null;
}

// 価格表タブの内容
function PriceTableTabContent(props) {
  const [page, setPage] = useState(1);

  const priceData = props.dataList;

  const handleChangeTablePage = (event, page_num) => {
    setPage(page_num);
  };

  var leftDataMinIndex = 2 * (page - 1) * maxPriceTableRows;
  var rightDataMinIndex = (2 * page - 1) * maxPriceTableRows;

  var leftTableData = [];
  var rightTableData = [];

  if (leftDataMinIndex < priceData.length) {
    leftTableData = priceData.slice(
      leftDataMinIndex,
      Math.min(rightDataMinIndex, priceData.length)
    );
  }
  if (rightDataMinIndex < priceData.length) {
    rightTableData = priceData.slice(
      rightDataMinIndex,
      Math.min(rightDataMinIndex + maxPriceTableRows, priceData.length)
    );
  }

  return (
    <Box>
      <Grid container spacing={2} marginBottom={2}>
        <Grid item xs={6}>
          <PriceEditTable data={leftTableData} minIndex={leftDataMinIndex} />
        </Grid>
        <Grid item xs={6}>
          <PriceEditTable data={rightTableData} minIndex={rightDataMinIndex} />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Pagination
            count={Math.ceil(priceData.length / (maxPriceTableRows * 2))}
            value={page}
            variant="outlined"
            shape="rounded"
            onChange={handleChangeTablePage}
            sx={{ display: "inline-block" }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

// 注文確認ページ
export default function OrderDataCheckPage() {
  const [tableTabPosition, setTableTabPosition] = useState(0);

  const handleChangeTab = (event, tabPos) => {
    setTableTabPosition(tabPos);
  };

  return (
    <CompanyTitledPage title="注文確認">
      <Typography sx={{ fontWeight: "bold", fontSize: 30 }}>
        テストスーパー　伊那店　様　注文票
      </Typography>

      <Typography sx={{ fontSize: 20, textAlign: "right" }}>
        出荷日 : {getYearMonthDateDisplay(getDateAfter(new Date(), 1))}
      </Typography>

      <Box marginTop={2} marginBottom={2}>
        <Grid container alignItems="baseline" spacing={2}>
          <Grid item xs>
            <Tabs value={tableTabPosition} onChange={handleChangeTab}>
              <Tab label="蔬菜" value={0} />
              <Tab label="果物" value={1} />
              <Tab label="スポット" value={2} />
            </Tabs>
          </Grid>
          <Grid item xs="auto">
            <Button variant="contained">注文票pdf保存</Button>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <TableTabContent tabPosition={tableTabPosition} value={0}>
          <PriceTableTabContent dataList={vegetableOrderList} />
        </TableTabContent>
        <TableTabContent tabPosition={tableTabPosition} value={1}>
          <PriceTableTabContent dataList={fruitOrderList} />
        </TableTabContent>
        <TableTabContent tabPosition={tableTabPosition} value={2}>
          <PriceTableTabContent dataList={spotOrderList} />
        </TableTabContent>
      </Box>
    </CompanyTitledPage>
  );
}
